import { render, staticRenderFns } from "./organiser-bar.vue?vue&type=template&id=b0619dbc&scoped=true"
import script from "./organiser-bar.vue?vue&type=script&lang=js"
export * from "./organiser-bar.vue?vue&type=script&lang=js"
import style0 from "./organiser-bar.vue?vue&type=style&index=0&id=b0619dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0619dbc",
  null
  
)

export default component.exports